import { Center, ErrorBoundary, Loader } from "@dutyon/ui-kit";
import { Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { routes } from "./routes";
import "@dutyon/ui-kit/styles.css";

const router = createBrowserRouter(routes);

function App() {
  return (
    <ErrorBoundary
      homePath="/"
      serviceName="DutyOn Dashboard"
      logoSrc="/logo.png"
      homeLabel="대시보드 홈"
    >
      <Suspense
        fallback={
          <Center style={{ width: "100vw", height: "100vh" }}>
            <Loader size="xl" />
          </Center>
        }
      >
        <RouterProvider router={router} />
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;
